import React from 'react';
const includesList = ['Todo el MegaPack Base', 'Todo el MegaPack Gestión Completa', '6 Planillas Clínicas', 'Gabinete Visual Completo'];
const mockupItems = [{
  id: 'poster',
  emoji: '🖼️',
  label: 'Posters Educativos',
  sub: 'Posters',
  border: '#60a5fa',
  bg: 'linear-gradient(135deg, #bfdbfe, #93c5fd)',
  textColor: 'text-blue-700',
  imageUrl: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1780460847/hf_20260603_040608_a2c32455-9fd8-4c34-b5aa-219f2dfba207_ztansn.webp'
}, {
  id: 'tarjeta',
  emoji: '🪪',
  label: 'Tarjetas Imprimibles',
  sub: 'Tarjetas Interactivas',
  border: '#34d399',
  bg: 'linear-gradient(135deg, #d1fae5, #6ee7b7)',
  textColor: 'text-emerald-700',
  imageUrl: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1780460867/hf_20260603_041157_654928bf-2fe2-490e-92b1-6c5bae7613b3_micgth.webp'
}, {
  id: 'imprimibles',
  emoji: '🎨',
  label: 'Dibujar y Colorear',
  sub: 'Dibujar y Colorear',
  border: '#f472b6',
  bg: 'linear-gradient(135deg, #fce7f3, #fbcfe8)',
  textColor: 'text-pink-700',
  imageUrl: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1780460867/hf_20260603_041533_8789587e-d577-4722-b114-9945fd6266e4_e7ig64.webp'
}, {
  id: 'familias',
  emoji: '🏠',
  label: 'Actividades para Casa',
  sub: 'Actividades para casa',
  border: '#fbbf24',
  bg: 'linear-gradient(135deg, #fef3c7, #fde68a)',
  textColor: 'text-amber-700',
  imageUrl: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1780460867/hf_20260603_041900_cf6466f5-3fc1-47d5-8be5-d62000185a39_gozdpr.webp'
}];
export function ProBusiness() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(236,254,255) 0%, rgb(248,250,252) 60%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-223">
      <div className="mx-auto max-w-3xl" data-id="element-224">
        {/* Badge */}
        <div className="flex justify-center mb-4" data-id="element-225">
          <span className="text-sm sm:text-base font-black text-white px-6 py-2.5 rounded-full" style={{
          background: 'linear-gradient(135deg, #f59e0b, #d97706)'
        }} data-id="element-226">
            🏆 OFERTA 3 — LA MÁS COMPLETA
          </span>
        </div>

        {/* Header */}
        <h2 className="text-3xl sm:text-4xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-227">
          MegaPack{' '}
          <span style={{
          background: 'linear-gradient(135deg, #f59e0b, #d97706)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }} data-id="element-228">
            Consultorio Profesional
          </span>
        </h2>
        <p className="text-center text-sm text-gray-500 mx-auto max-w-xl m-0 mb-10" data-id="element-229">
          Todo lo que necesitás para que tu consultorio se vea, funcione y cobre
          como el espacio profesional que es.
        </p>

        {/* Mockup Area */}
        <div className="rounded-2xl overflow-hidden mb-10 shadow-lg" style={{
        background: 'linear-gradient(135deg, #fef3c7 0%, #e0f2fe 100%)',
        border: '2px solid #fcd34d'
      }} data-id="element-230">
          {/* Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 p-6 pb-4" data-id="element-231">
            {mockupItems.map(item => <div key={item.id} className="flex flex-col items-center gap-2" data-id="element-232">
                {/* Recuadro imagen */}
                <div className="w-full rounded-xl overflow-hidden shadow-md" style={{
              height: '140px',
              background: item.imageUrl ? 'transparent' : item.bg,
              border: `2px dashed ${item.border}`
            }} data-id="element-233">
                  {item.imageUrl ? <img src={item.imageUrl} alt={item.label} className="w-full h-full object-cover" data-id="element-234" /> : <div className="w-full h-full flex flex-col items-center justify-center gap-1 px-2" data-id="element-235">
                      <div className="text-3xl" data-id="element-236">{item.emoji}</div>
                      <div className={`text-[11px] font-black text-center leading-tight ${item.textColor}`} data-id="element-237">
                        {item.label}
                      </div>
                    </div>}
                </div>

                {/* Subtítulo debajo del recuadro */}
                <span className="text-[10px] text-gray-500 font-semibold text-center leading-tight" data-id="element-238">
                  {item.sub}
                </span>
              </div>)}
          </div>

          {/* Label inferior — fuera del absolute, dentro del flujo */}
          <div className="mx-4 mb-4 rounded-xl px-4 py-2 flex items-center justify-center" style={{
          background: 'rgba(255,255,255,0.8)'
        }} data-id="element-239">
            <span className="text-[11px] font-black text-amber-600 uppercase tracking-wide text-center" data-id="element-240">
              🎨 Gabinete Visual Completo — exclusivo Oferta 3
            </span>
          </div>
        </div>

        {/* Qué incluye */}
        <div className="bg-white rounded-2xl border border-amber-200 overflow-hidden shadow-sm" data-id="element-241">
          <div className="px-5 py-3" style={{
          background: 'linear-gradient(135deg, #fef3c7, #fde68a)'
        }} data-id="element-242">
            <h3 className="text-sm font-black text-amber-800 m-0 tracking-wide uppercase" data-id="element-243">
              ✅ Todo lo que incluye:
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-244">
            {includesList.map(item => <div key={item} className="flex items-center gap-3 px-5 py-3" data-id="element-245">
                <span className="shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-black text-white" style={{
              background: 'linear-gradient(135deg, #f59e0b, #d97706)'
            }} data-id="element-246">
                  ✓
                </span>
                <span className="text-sm font-bold text-gray-900" data-id="element-247">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}